export const formCopy = {
    title: "Vul je gegevens in",
    labels: {
        firstName: "Voornaam",
        insertion: "Tussenvoegsel",
        lastName: "Achternaam",
        email: "E-mailadres",
        zipCode: "Postcode",
        houseNumber: "Huisnr.",
        addition: "Toevoeging",
        street: "Straatnaam",
        city: "Plaats",
        mobile: "Mobiel nummer.",
        damageDate: "Datum van schade",
        damageNumber:
            "Heeft u al een schade nummer? Dan kunt u deze hier meegeven en kunnen wij u sneller helpen.",
        greenCard: "Groene kaartnummer",
    },
    placeholders: {
        greenCard: "NL 111 2222 333344445555",
    },
    errors: {
        firstName: "Voer een valide voornaam in",
        lastName: "Voer een valide achternaam in",
        email: "Voer een valide e-mailadres in",
        zipCode: "Voer een valide postcode in",
        houseNumber: "Voer een valide huisnummer in",
        street: "Voer een valide straatnaam in",
        city: "Voer een valide plaatsnaam in",
        mobile: "Voer een valide telefoonnummer in",
        greenCard: "Voer een valide groene kaartnummer in",
    },
    actions: {
        summary: "Bekijk samenvatting",
    },
} as const;
